module.exports = __webpack_public_path__ + "img/5-1.9bba7110.png";